import { TimelineRequestEntity } from 'src/entities/TimelineRequest.entity';

/** `computeOpsForCycle` が 1 回転分の legRun から組み立てる停車 1 件 */
export type ComputedTimelineOp = {
  shift_truck_id: number;
  order_id: number;
  arrival_at: Date;
  departure_at: Date;
  action: '積' | '降';
  cycle: number;
};

/**
 * `computeOpsForCycle` の停車列を timeline のリクエスト本文へ写す。
 * 既存 operation があれば id を引き継ぎ、無ければ 0 (新規) を送る。
 *
 * Why not `changed: true`: API は `changed` を「この停車の作業時間を保存せよ」の指示として読み、
 * `departure_at - arrival_at` を滞在時間として `shipment_order_waypoints.staying_seconds` に
 * 書き込む (`TimelinePlanningJob#update_orders`)。これはタイムライン配車がセルを伸縮して
 * 作業時間を調整するための機能で、カード配車にその UI は無い。
 * ここの arrival/departure は `computeOpsForCycle` が並び順のためだけに合成した値
 * (同一地点はグループ内の最大滞在時間で束ね、2 件目以降は arrival = departure) なので、
 * 送ると (a) 0 秒の停車で `Updating order failed` がログに出て、
 * (b) 同一地点の 1 件目の作業時間が他案件の値で上書きされる。並び順は `changed` とは無関係に
 * `timeline_edit_deliveries` の work_start_time で伝わるため、常に false で送る (logposeTech/planning_api#2554)。
 */
export function buildTimelineRequestEntities(
  ops: ComputedTimelineOp[],
  existingOperationIdOf: (legRunId: number, action: string) => number | undefined,
): TimelineRequestEntity[] {
  return ops.map((op) => ({
    id: existingOperationIdOf(op.order_id, op.action) ?? 0,
    shift_truck_id: op.shift_truck_id,
    order_id: op.order_id,
    arrival_at: op.arrival_at,
    departure_at: op.departure_at,
    action: op.action,
    cycle: op.cycle,
    changed: false,
  }));
}
